/**
 * Canvas arc preview for 3-click arc tool (start, end, bulge).
 */

/** Quadratic bezier through start, bulge control, end — pilot arc representation. */
export function paintArcBezierPreview(ctx, start, end, bulge, { stroke = 'rgba(233, 112, 36, 0.85)', width = 2 } = {}) {
  if (!ctx || !start || !end || !bulge) return;
  ctx.save();
  ctx.beginPath();
  ctx.moveTo(start.x, start.y);
  ctx.quadraticCurveTo(bulge.x, bulge.y, end.x, end.y);
  ctx.strokeStyle = stroke;
  ctx.lineWidth = width;
  ctx.setLineDash([6, 4]);
  ctx.stroke();
  ctx.restore();
}
